var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.924,
    viewBox: "0 0 14 14.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.085,
    y1: -0.128,
    x2: 0.626,
    y2: 1.123,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#081521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c4c6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.492,
    y1: 0.127,
    x2: 0.125,
    y2: 0.822,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3d400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91b508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.312,
    y1: 0.56,
    x2: 0.745,
    y2: 0.358,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3a9e52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91b508"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7872",
    "data-name": "Group 7872",
    transform: "translate(-57.275 -57.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7871",
    "data-name": "Group 7871",
    transform: "translate(25.125 24.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M45.677,83.488l-6.031-5.961-7.5,7.408H45.07A.847.847,0,0,0,45.677,83.488Z",
    transform: "translate(0 -36.927)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M32.15,33.192l4.333,2.485a.843.843,0,0,1,.363,1.056l-4.7,11.275Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M45.07,33.192H32.15l4.333,2.485a.843.843,0,0,1,.363,1.056l-4.7,11.275L45.677,34.64A.847.847,0,0,0,45.07,33.192Z",
    fill: "url(#linear-gradient-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCustomer);
export default __webpack_public_path__ + "static/media/Logo_Customer.1b0c011b711787cd471d7b038da57d66.svg";
export { ForwardRef as ReactComponent };